import { render, staticRenderFns } from "./ticket-copy.vue?vue&type=template&id=1df58d69&scoped=true&"
import script from "./ticket-copy.vue?vue&type=script&lang=js&"
export * from "./ticket-copy.vue?vue&type=script&lang=js&"
import style0 from "./ticket-copy.vue?vue&type=style&index=0&id=1df58d69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df58d69",
  null
  
)

export default component.exports